import { useState } from "react";

import { getLabel } from "../../../../../../hooks/use-labels";
import ReviewFormDialog from "../../../../../../features/reviews/components/ReviewFormDialog";
import { TARGET_TYPES } from "../../../../../../features/reviews/reviewsMappers";

const ReviewButtonCard = ({ supplier, title }) => {
  const [open, setOpen] = useState(false);

  if (!supplier?.id) return null;

  return (
    <section className="ord-panel">
      {open && (
        <ReviewFormDialog
          targetType={TARGET_TYPES.SUPPLIER}
          targetId={supplier.id}
          targetName={supplier.name}
          onClose={() => setOpen(false)}
        />
      )}

      <button
        type="button"
        className="ord-btn ord-btn-primary ord-btn-block"
        onClick={() => setOpen(true)}
      >
        {title || getLabel("addReviewLabel")}
      </button>
    </section>
  );
};

export default ReviewButtonCard;
